
var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer ------------------- Start
  function fontResizer() {
    var perc = parseInt(sw) / 120;
    document.body.style.fontSize = perc + 'px';
  }
  

// Loader ------------------- Start
  function pageLoader() {
    // document.querySelector("html").classList.add("loadjs");
    setTimeout(function () {
      if(document.querySelector(".loader-first")) {
        document.querySelector(".loader-first").style.display = "none";
        document.querySelector("html").classList.remove("loadjs");
      }
    }, 700);
  }

  // Window on Load ----------------- Start
  window.onload = function () {
    pageLoader();
    if (sw > 1199) {
      fontResizer();
    }
  };

// Window On Resize ----------------- Start
(function () {
  window.addEventListener('resize', (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) {} else {
        fontResizer();
      }
    }
  });
})();




// Landscape Mode off ---------------- Start
  const mql = window.matchMedia("(orientation:landscape)");
  mql.addEventListener("change", (event) => {
    if (event.matches) {
      if (innerWidth < 930) {
        // console.log("Now in landscape orientation");
        document.getElementById("portrait-warning").style.display = "flex";
      }
    } else {
      // console.log("Now in portrait orientation");
      document.getElementById("portrait-warning").style.display = "none";
    }
  });


// Sticky Header ---------------- Start
(function () {
  if (document.querySelector('.header')) {
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    window.addEventListener('scroll', (event) => {
      stickyHeader();
    });
  }
})();





// SVG Convert Code
window.addEventListener("load", function() {
  (function() {
    if(document.querySelector(".svg-convert")) {
      let svgs = document.querySelectorAll('img.svg-convert');
      svgs.forEach((el) => {
        const imgID = el.getAttribute('id');
        const imgClass = el.getAttribute('class');
        const imgURL = el.getAttribute('src');
    
        fetch(imgURL)
          .then((response) => response.text())
          .then(data => {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(data, 'text/html');
              let svg = xmlDoc.querySelector('svg');
              if (typeof imgID !== 'undefined') {
                  svg.setAttribute('id', imgID);
              }
    
              if (typeof imgClass !== 'undefined') {
                  svg.setAttribute('class', imgClass + ' svg-converted');
              }
    
              svg.removeAttribute('xmlns:a');
    
              el.parentNode.replaceChild(svg, el);
          })
      });
    }
  }) ();

});


// Navigation slide Active on a mobile and tab and ipad ---------------- Start
(function () {
  if (document.querySelector('#toggle')) {
    let toggleMenu = document.querySelector('#toggle');
    let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      // console.log('this', event)
      let _this = event.target;
      _this.classList.toggle('active');
      document.querySelector('.navigation').classList.toggle('open')
      htmlEl.classList.toggle("overflow-hidden");
    })
  }
})();


// navigation accordion
(function() {
  if(sw < 1200) {
    let dropdown = document.querySelectorAll(".dropdown");
    dropdown.forEach(function(dp) {
      let dropdownItem = dp.closest(".menu__menuitem");
      dropdownItem.classList.add("dropdown-active");
    });
  
    let accordionNav = document.querySelectorAll(".menu__menuitem.dropdown-active");
    let iterator;

    for (iterator = 0; iterator < accordionNav.length; iterator++) {
      accordionNav[iterator].querySelector(".menu__menuitem__icon").addEventListener("click", function (e) {
        e.stopPropagation();
        let currentItem = e.target;

        // console.log(currentItem)

        let panel = this.nextElementSibling;
        if(currentItem.classList.contains('open')) {
          currentItem.classList.remove("open");
          panel.style.maxHeight = '0px';
        } else {
          let mainItem = currentItem.closest(".menu").querySelectorAll(".menu__menuitem__icon");
            mainItem.forEach(function(itm) {
            itm.classList.remove("open");
            itm.nextElementSibling.style.maxHeight = '0px';
          });
          currentItem.classList.add("open");
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }
  }
})();



// animate Observer------------Start
(function() {
  if (window.innerWidth > 767) {
    let anim = [...document.querySelectorAll(".animate")];
  
    let options = {
      rootMargin: "0px",
      threshold: 0.2,
    };
  
    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 1s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };
  
    let observer = new IntersectionObserver(animate, options);
  
    anim.forEach((item, idx) => {
      observer.observe(item);
    });
  }
})();


// Lazy Load Img observer
(function() {
  document.addEventListener("DOMContentLoaded", () => {
    const imgElements = document.querySelectorAll("img[data-src]");
  
    const lazyLoadingImage = (entries, observer2) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.src = entry.target.dataset.src;
        entry.target.addEventListener("load", () => {
          entry.target.classList.remove("lazy-img");
          observer2.unobserve(entry.target);
        });
      });
    };
    const lazyLoadingObserver = new IntersectionObserver(lazyLoadingImage, {
      threshold: 0,
      rootMargin: "0px 0px 150px 0px",
    });
    imgElements.forEach((img) => lazyLoadingObserver.observe(img));
  });
})();



// clip path observer
(function() {

  if(window.innerWidth > 767) {

    let imageObserver = [...document.querySelectorAll(".img__observer")];
    let option = {
      rootMargin: "-200px",
      threshold: 0.2,
    };
  
    let setItemActive = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    };
  
    let observer2 = new IntersectionObserver(setItemActive, option);
  
    imageObserver.forEach((item1, idx) => {
      observer2.observe(item1);
    });


  }

})();



// main navigation hover
(function () {
  if (sw > 1199) {

    let menuitems = document.querySelectorAll(".navigation > .menu > .menu__menuitem");

    menuitems.forEach(function(menuitem) {
      if(menuitem.children[2]) {
        
        let first__menuLink = menuitem.querySelector(".navigation--main .menu__menuitem--menulink ");
            first__menuLink.classList.add("active");
        
        let firstSrc =  first__menuLink.dataset.src,
            firstTitle = first__menuLink.dataset.title;

        let currentNavigationMain = menuitem.querySelector(".navigation-wrapper--main"),
            currentFigure = currentNavigationMain.querySelector(".navigation--main__content__card__figure .menu-img"),
            currentTitleEl = currentNavigationMain.querySelector(".navigation--main__content__card__text");

        currentFigure.setAttribute("src",firstSrc);
        currentTitleEl.textContent = firstTitle;

      }

    });
    

    let mainItems = document.querySelectorAll(".navigation--main .menu__menuitem--menulink");
      
    mainItems.forEach(function(item) {

      item.addEventListener("mouseover", function (evt) {
        evt.stopPropagation();
        if(evt.target.matches(".menu__menuitem--menulink")) {
          mainItems.forEach(function (itm) {
            itm.classList.remove("active");
          });

          evt.target.classList.add("active");

          let currentCardSrc = evt.target.dataset.src,
              currentDataTitle = evt.target.dataset.title;


          let currentNavigationMain = evt.target.closest(".navigation-wrapper--main"),
              currentFigure = currentNavigationMain.querySelector(".navigation--main__content__card__figure .menu-img"),
              currentTitleEl = currentNavigationMain.querySelector(".navigation--main__content__card__text");
  
              currentFigure.setAttribute("src",currentCardSrc);
              currentTitleEl.textContent = currentDataTitle;


              let navigationMain = evt.target.closest(".navigation--main");
              navigationMain.querySelector(".navigation--main__content__card").classList.add("active");



        }

      });

      item.addEventListener("mouseout", function(evt) {
        evt.stopPropagation();
        if(evt.target.matches(".menu__menuitem--menulink")) {
          let navigationMain = evt.target.closest(".navigation--main");
          navigationMain.querySelector(".navigation--main__content__card").classList.remove("active");
          

          menuitems.forEach(function(menuitem) {
            if(menuitem.children[2]) {

              
              let first__menuLink = menuitem.querySelector(".navigation--main .menu__menuitem--menulink ");
                  first__menuLink.classList.add("active");
              
              let firstSrc =  first__menuLink.dataset.src,
                  firstTitle = first__menuLink.dataset.title;
      
              let currentNavigationMain = menuitem.querySelector(".navigation-wrapper--main"),
                  currentFigure = currentNavigationMain.querySelector(".navigation--main__content__card__figure .menu-img"),
                  currentTitleEl = currentNavigationMain.querySelector(".navigation--main__content__card__text");

                  // console.log(currentFigure)
      
              currentFigure.setAttribute("src",firstSrc);
              currentTitleEl.textContent = firstTitle;
      
            }
      
          });
        }


      });


    });
  }
})();






// -------------------- above code will be common for all websites --------------------------


// (function() {
//   if (document.querySelector('.project-detail__sliders')) {
//     let projectThumb = new Swiper(".project-detail__sliders__small > .swiper", {
//       spaceBetween: 20,
//       slidesPerView: 3,
//       direction: 'horizontal',
//       freeMode: true,
//       watchSlidesProgress: true,
//       breakpoints: {
//         768: {
//           direction: 'vertical',
//         }
//       },
//     });

//     let projectMain = new Swiper(".project-detail__sliders__large  > .swiper ", {
//       spaceBetween: 10,
//       slidesPerView: 1,
//       thumbs: {
//         swiper: projectThumb,
//       },
//     });
//   }
// })();

// custom select to
(function () {
  var x, i, j, l, ll, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      let heroformDropdown = document.querySelectorAll(
        ".hero-form__col:not(.hero-form__col--btnn) .hero-form__dropdown"
      );
      heroformDropdown.forEach(function (elmt) {
        elmt.classList.remove("active");
      });

      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
  document.addEventListener("click", closeAllSelect);
})();




function Accordion1() {

  if(document.querySelector('.c-accordion')) {
    let c__accordion = document.querySelector('.c-accordion'),
        c__buttons = c__accordion.getElementsByClassName('c-accordion__button'),
        c__collapses = c__accordion.getElementsByClassName('c-accordion__collapse');

        c__buttons[0].classList.add('active');
        c__collapses[0].classList.add('show');
        c__collapses[0].style.maxHeight = c__collapses[0].scrollHeight + 'px';
  
  
    c__accordion.addEventListener('click', function(e) {
        let currentElement = e.target;
        // console.log(e);
        // console.log(this);
  
        // for accordion buttons
        if(currentElement.matches(".c-accordion__button.active")) {
            for (const c_button of c__buttons) {
                c_button.classList.remove('active');
            }
            for (const c_collapse of c__collapses) {
                c_collapse.classList.remove('show');
                c_collapse.style.maxHeight = 0;
            }
        }
        else {
            if(currentElement.matches(".c-accordion__button")) {
                let currentCollapse = currentElement.closest('.c-accordion__header').nextElementSibling;
                // console.log('if')
                for (const c_button of c__buttons ) {
                    c_button.classList.remove('active');   
                }
                currentElement.classList.add('active');
                
                for (const c_collapse of c__collapses) {
                    c_collapse.classList.remove('show');
                    c_collapse.style.maxHeight = 0;
                }
                currentCollapse.classList.add('show');
                currentCollapse.style.maxHeight = currentCollapse.scrollHeight + 'px';
            }
        }
  
    });
  }
}

Accordion1();


if(document.querySelector(".what-we__slider-wrapper")) {
   const tabs = document.querySelectorAll('.c-tab .rectangle-btn');
   tabs.forEach(tab => {
     tab.addEventListener('click', () => {
       // Remove the 'active' class from all tabs
       tabs.forEach(t => t.classList.remove('active'));   
       // Add the 'active' class to the clicked tab
       tab.classList.add('active');
   
       // Get the category from the data-category attribute
       const category = tab.getAttribute('data-category');

      document.querySelectorAll('.what-we__slider-wrapper .col_12').forEach(slide => {
        if (slide.classList.contains(category)) {
          slide.style.display = 'block'; // Show matching slides
        } else {
          slide.style.display = 'none'; // Hide non-matching slides
        }
      });
     });
   });
 }

//  Custome Input File Field for html
(function () {
  if (document.querySelector('.c_form-field')) {
    (function (document, window, index) {
      var inputs = document.querySelectorAll('.c_form-field:not(.inputFileField) .inputfile');
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;

        input.addEventListener('change', function (e) {
          var fileName = '';
          if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
          else
            fileName = e.target.value.split('\\').pop();

          if (fileName)
            label.querySelector('span').innerHTML = fileName;
          else
            label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () {
          input.classList.add('has-focus');
        });
        input.addEventListener('blur', function () {
          input.classList.remove('has-focus');
        });
      });
    }(document, window, 0));
  }
})();


// for wordpress
(function () {
  if (document.querySelector('.c_form-field.inputFileField')) {
    (function (document, window, index) {
      var inputs = document.querySelectorAll('.inputFileField');
      Array.prototype.forEach.call(inputs, function (input) {

        var label = input.querySelector(".wpcf7-form-control-wrap").nextElementSibling,
          labelVal = label.innerHTML;
        input.querySelector(".wpcf7-form-control-wrap input").addEventListener('change', function (e) {
          var fileName = '';
          if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
          else
            fileName = e.target.value.split('\\').pop();

          if (fileName)
            label.querySelector('span').innerHTML = fileName;
          else
            label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () {
          input.classList.add('has-focus');
        });
        input.addEventListener('blur', function () {
          input.classList.remove('has-focus');
        });
      });
    }(document, window, 0));
  }
})();





if(document.querySelector(".related-projects__sliders-wrapper")) {
  const swiperRelated = new Swiper('.related-projects__sliders-wrapper .swiper', {
    // grabCursor: true,
    centeredSlides: true,
    loop: true,
    spaceBetween: 20,
    observeParents: true,
    observer: true,
    effect: "coverflow",
    coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 650,
        modifier: 1, 
        slideShadows: true,
    },
    breakpoints: { 
      992: {
        slidesPerView: 2.3,
        spaceBetween: 30,
      },
    }
    

  });

  window.onresize = queryResizer
  queryResizer()
  function queryResizer() {
      if (window.innerWidth > 0) swiperRelated.params.slidesPerView = 1
      if (window.innerWidth > 768) swiperRelated.params.slidesPerView = 1.5
      if (window.innerWidth > 992) swiperRelated.params.slidesPerView = "auto"
      swiperRelated.update()
  }

}


function Cursor() {

  if(document.querySelector(".related-projects__sliders-wrapper")) {
    let boxes = document.querySelectorAll(".related-projects__sliders-wrapper .related-card"),
        section = document.querySelector(".related-projects__sliders-wrapper"),
        cursorElement = document.querySelector(".cursor");
  
        boxes.forEach(function(box) {
            box.addEventListener('mousemove', function(e) {
                e.stopPropagation();
                if(e.target.closest(".related-projects__sliders-wrapper .swiper-slide")) {
                    cursorElement.classList.add("show");
                    cursorElement.style.left = (e.clientX)+'px';
                    cursorElement.style.top = (e.clientY)+'px';
                }
            });
        });
  
        section.addEventListener('mouseout', function(e) {
            e.stopPropagation();
            cursorElement.classList.remove("show");
        });
  }


}

Cursor();






function Modal(modalMainWrapper, backdrop, show) {

  let modal = document.querySelector(modalMainWrapper),
  modal_backdrop = document.querySelector(backdrop),
  show_modals = document.querySelectorAll(show),
  rootEl = document.querySelector("html");

  show_modals.forEach(function(show_modal) {
    show_modal.addEventListener("click", function(e) {
        e.stopPropagation();
        modal.classList.add("show");
        modal_backdrop.classList.add("show");
        rootEl.classList.add("modal-root-hidden");
    });

  });

  
  document.addEventListener("click", function(e) {
      e.stopPropagation();
      if(e.target.closest(".modal")) {
          // console.log("modal")
          if(e.target.matches(".modal__cancel")) {
              // console.log(e.target.matches(".modal__cancel")  )
              modal.classList.remove("show");
              modal_backdrop.classList.remove("show");
              rootEl.classList.remove("modal-root-hidden");
          }
      }
      else {
          modal.classList.remove("show");
          modal_backdrop.classList.remove("show");
          rootEl.classList.remove("modal-root-hidden");
      }
  });
}




if(document.querySelector('.modal--enquire')) {
  Modal(".modal--enquire", ".modal-backdrop--enquire", ".show-modal--enquire");
}

if(document.querySelector('.modal--job')) { 
  Modal(".modal--job", ".modal-backdrop--job", ".show-modal--job");
}



// modal for projects
function ModalProject(modalMainWrapper, backdrop, show) {

  let modal = document.querySelector(modalMainWrapper),
  modal_backdrop = document.querySelector(backdrop),
  show_modals = document.querySelector(show),
  // show_modalsParent = show_modals.closest(".what-we__slider-wrapper"),
  show_modalsParent = show_modals.closest(".general-pop-up-what-we__slider-wrapper"),
  rootEl = document.querySelector("html");

  show_modalsParent.addEventListener("click", function(e) {
      e.stopPropagation();
      if(e.target.matches(".show-modal--project")) {
        modal.classList.add("show");
        modal_backdrop.classList.add("show");
        rootEl.classList.add("modal-root-hidden");
      }
  });

  
  document.addEventListener("click", function(e) {
      e.stopPropagation();
      if(e.target.closest(".modal")) {
          // console.log("modal")
          if(e.target.matches(".modal__cancel")) {
              // console.log(e.target.matches(".modal__cancel")  )
              modal.classList.remove("show");
              modal_backdrop.classList.remove("show");
              rootEl.classList.remove("modal-root-hidden");
          }
      }
      else {
          modal.classList.remove("show");
          modal_backdrop.classList.remove("show");
          rootEl.classList.remove("modal-root-hidden");
      }
  });
  
}

if(document.querySelector('.modal--project')) { 
  ModalProject(".modal--project", ".modal-backdrop--project", ".show-modal--project");
}



// if(document.querySelector('.modal--thankyou')) { 
//   Modal(".modal--thankyou", ".modal-backdrop--thankyou", ".show-modal--project");
// }






function Modal2(modalMainWrapper, backdrop, show) {
  let modal = document.querySelector(modalMainWrapper),
  modal_backdrop = document.querySelector(backdrop),
  show_modal = document.querySelector(show),
  rootEl = document.querySelector("html");

  show_modal.addEventListener("click", function(e) {
      e.stopPropagation();
      if(!this.classList.contains("show")) {
        modal.classList.add("show");
        modal_backdrop.classList.add("show");
        this.classList.add("show");
        rootEl.classList.add("modal-root-hidden");
        
      }
      else {
        modal.classList.remove("show");
        modal_backdrop.classList.remove("show");
        this.classList.remove("show");
        rootEl.classList.remove("modal-root-hidden");
      }

  });
  
  document.addEventListener("click", function(e) {
      e.stopPropagation();
      if(e.target.closest(".modal")) {
          // console.log("modal")
          if(e.target.matches(".modal__cancel")) {
              // console.log(e.target.matches(".modal__cancel")  )
              modal.classList.remove("show");
              modal_backdrop.classList.remove("show");
              show_modal.classList.remove("show");
              rootEl.classList.remove("modal-root-hidden");
          }
      }
      else {
          modal.classList.remove("show");
          modal_backdrop.classList.remove("show");
          show_modal.classList.remove("show");
          rootEl.classList.remove("modal-root-hidden");
      }
  });

}

if(document.querySelector(".modal--search")) {
  Modal2(".modal--search", ".modal-backdrop--search", ".show-modal--search");
}


// thankyou popup

// function thankYou(thankyou_modal, thankyou_backdrop) {
//   let modal = document.querySelector(thankyou_modal),
//       backdrop = document.querySelector(thankyou_backdrop);
    
//     modal.classList.add("show");
//     backdrop.classList.add("show");


//     document.addEventListener("click", function(e) {
//       e.stopPropagation();
//       if(e.target.closest(".modal")) {
//           // console.log("modal")
//           if(e.target.matches(".modal__cancel")) {
//               // console.log(e.target.matches(".modal__cancel")  )
//               modal.classList.remove("show");
//               backdrop.classList.remove("show");
//           }
//       }
//       else {
//           modal.classList.remove("show");
//           backdrop.classList.remove("show");
//       }
//   });
// }



// window.setTimeout(function() {
//   if(document.querySelector(".modal--thankyou")) {
//     thankYou(".modal--thankyou", ".modal-backdrop--thankyou");
//   }
// }, 4000);











